import templateUrl from './component.tpl.html';
import AlFontSelectorController from './controller';

angular.module('festzelt-os.modules.core')
    .component('alFontSelector', {
        bindings: {
            availableFonts: '<',
            currentConfig: '<',
            onConfigChange: '&',
            showExtendedSettings: '<',
            disabled: '<'
        },
        controller: AlFontSelectorController,
        controllerAs: 'vm',
        templateUrl
    })



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-font-selector/component.js